import { Expose } from "@nts/std/serialization";
import type { UserPanelMetaDataInterface } from '@nts/std/interfaces';
import { PanelState } from "@nts/std/types";

export class UserPanelMetaData implements UserPanelMetaDataInterface {
    constructor() {

    }

    @Expose()
    panelState: PanelState;

    @Expose()
    panelId: string;
}
